import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "id", "timezone", "variant", "labelledById"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import useUniqueId from 'hooks/useUniqueId';
import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';
import getSelectableTimes from 'utils/times/getSelectableTimes';
import Flex, { Box } from 'components/Flex';
import { Select, Option } from 'components/Select';
function TimePicker(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    timezone = _ref.timezone,
    variant = _ref.variant,
    labelledById = _ref.labelledById,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var uniqueId = useUniqueId();
  var timezoneId = "".concat(uniqueId, "-timezone");

  // Remove the seconds (if present), as these cannot be displayed in the time picker
  var timeInHourAndMinutes = "".concat(value === null || value === void 0 ? void 0 : value.split(':')[0], ":").concat(value === null || value === void 0 ? void 0 : value.split(':')[1]);
  return /*#__PURE__*/React.createElement(Flex, {
    wrap: true,
    align: "center"
  }, /*#__PURE__*/React.createElement(Select, _extends({
    id: id,
    menuPositionFixed: false,
    labelledById: labelledById,
    "aria-describedby": timezoneId,
    value: timeInHourAndMinutes,
    onChange: onChange,
    variant: variant,
    mr: "xxs"
  }, otherProps), getSelectableTimes(getUsersISOLocale()).map(function (time) {
    return /*#__PURE__*/React.createElement(Option, {
      key: time.value,
      value: time.value
    }, time.label);
  })), timezone && /*#__PURE__*/React.createElement(Box, {
    id: timezoneId,
    fontSize: "s"
  }, timezone));
}
export default TimePicker;